import React, { useEffect } from "react";
import {
  TextField,
  Button,
  InputLabel,
  Grid,
  Box,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import ColorPicker from "material-ui-color-picker";
import { Field } from "formik";
import { DropzoneArea } from "material-ui-dropzone";
import Stepper from "react-stepper-horizontal";
import { useFormikContext } from "formik";
import logoPartner from "./Screenshots/logoPartner.jpg";
import logoPartner2 from "./Screenshots/logoPartner2.jpg";

import CustomPopover from "../../../Popover/Popover";

const Step1 = (props) => {
  const { values } = useFormikContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stepValidated = () => {
    return props.touched.appName &&
      !props.errors.startDate &&
      !props.errors.endDate &&
      !props.errors.appName &&
      !props.errors.appLogo
      ? true
      : false;
  };

  const isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(
      !window["safari"] ||
        (typeof safari !== "undefined" && window["safari"].pushNotification)
    );

  const handleChange = (key, value) => {
    props.setFormState({ ...props.formState, [key]: value });
  };

  function rgbaToHex(color) {
    const rgba = color.replace(/^rgba?\(|\s+|\)$/g, "").split(",");
    const hex = `#${(
      (1 << 24) +
      (parseInt(rgba[0]) << 16) +
      (parseInt(rgba[1]) << 8) +
      parseInt(rgba[2])
    )
      .toString(16)
      .slice(1)}`;

    return hex;
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stepper
            titleFontSize={12}
            steps={[
              { title: "Application" },
              { title: "Inscription" },
              { title: "Course" },
            ]}
            activeStep={0}
          />
        </Grid>
      </Grid>

      <h3>
        Afin d’obtenir votre application sport à votre image, nous avons besoin
        d’informations préalables (3 étapes).
      </h3>
      <i style={{ fontSize: "13px" }}>
        Avant de vous lancer dans le paramétrage de votre application, veuillez
        vous assurer d'avoir :
        <ul>
          <li>Un logo</li>
          <li>Une Trace GPX</li>
        </ul>
      </i>

      <h2>
        Configuration de votre <span>application</span>
      </h2>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Field name="appName">
            {({ field, form, meta }) => (
              <TextField
                required
                error={meta.touched && meta.error ? true : false}
                helperText={meta.touched && meta.error ? meta.error : ""}
                id="appName"
                type="text"
                label="Nom de l'application"
                {...field}
                InputProps={{
                  endAdornment: (
                    <CustomPopover>
                      <p>
                        <i>
                          Ce sera le nom de votre application qui sera présent
                          dans le Play Store.
                        </i>
                      </p>
                    </CustomPopover>
                  ),
                }}
              />
            )}
          </Field>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
          className="GridSwitchTimeLimit">
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={
                  !isSafari && props.formState.timeRangeAppUse ? true : false
                }
                onChange={(e) =>
                  !isSafari &&
                  props.setFormState({
                    ...props.formState,
                    timeRangeAppUse: e.target.checked,
                  })
                }
                disabled={isSafari}
                name="timeRangeAppUse"
              />
            }
            label="Utilisation de l'application limitée dans le temps ?"
          />
          <CustomPopover>
            <p>
              <i>
                La période sur laquelle les classements seront accessibles, par
                défaut, est d'un mois
              </i>
            </p>
          </CustomPopover>
        </Grid>
        <Grid item xs={12}>
          {isSafari ? (
            <i style={{ opacity: "0.6", fontSize: "12px" }}>
              * Afin de modifier les dates, merci d'utiliser un navigateur
              différent.
            </i>
          ) : (
            ""
          )}
        </Grid>
        <Grid item xs={12} className="GridHelperTextField">
          <InputLabel>Plage de l'utilisation de l'application.</InputLabel>
        </Grid>
        <Grid item xs={12} md={6}>
          <Field name="startDate">
            {({ field, form, meta }) => (
              <div>
                <TextField
                  disabled={!props.formState.timeRangeAppUse}
                  type="date"
                  id="startDate"
                  label="Date de début"
                  defaultValue={undefined}
                  error={
                    meta.touched &&
                    meta.error &&
                    props.formState.timeRangeAppUse
                  }
                  helperText={meta.touched && meta.error}
                  {...field}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    props.setFieldValue("startDate", e.target.value);
                    console.log(e.target.value);
                    if (e.target.value)
                      return props.setFormState({
                        ...props.formState,
                        startDate: e.target.value,
                      });
                    return undefined;
                  }}
                />
              </div>
            )}
          </Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <Field name="endDate">
            {({ field, form, meta }) => (
              <TextField
                disabled={!props.formState.timeRangeAppUse}
                id="endDate"
                label="Date de fin"
                type="date"
                error={
                  meta.touched && meta.error && props.formState.timeRangeAppUse
                }
                helperText={
                  meta.touched && meta.error && props.formState.timeRangeAppUse
                    ? meta.error
                    : ""
                }
                {...field}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  props.setFieldValue("endDate", e.target.value);
                  if (e.target.value)
                    return props.setFormState({
                      ...props.formState,
                      endDate: e.target.value,
                    });
                  return undefined;
                }}
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={6} md={6} style={{ display: "flex" }}>
          <Box mb={1}>
            <InputLabel>Couleur primaire de l'application.</InputLabel>
          </Box>
          <ColorPicker
            className="color-picker"
            name="color"
            defaultValue="#000"
            value={props.formState.color}
            TextFieldProps={{
              value: props.formState.color,
            }}
            InputProps={{
              endAdornment: (
                <div
                  className="CircleColor"
                  style={{
                    background: props.formState.color,
                  }}
                />
              ),
            }}
            onChange={(value) => {
              if (value.substring(0, 4) === "rgba") {
                props.setFieldValue("color", rgbaToHex(value));
                props.setFormState({
                  ...props.formState,
                  color: rgbaToHex(value),
                });
              } else {
                props.setFieldValue("color", value);
                props.setFormState({
                  ...props.formState,
                  color: value,
                });
              }
            }}
          />
          <Grid item xs={2} md={2} style={{ marginTop: "3px" }}>
            {" "}
            <CustomPopover>
              <p>
                <i>
                  Cette couleurs sera presente au niveau des boutons d'action
                  dans l'application.
                </i>
              </p>
            </CustomPopover>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box mb={1}>
            <InputLabel
              className="helpIcon"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}>
              Choisissez le logo de l'application (Au format PNG) *
            </InputLabel>
          </Box>
          <Field name="appLogo">
            {({ field, form, meta }) => (
              <DropzoneArea
                filesLimit={1}
                noKeyboard={false}
                acceptedFiles={["image/png"]}
                dropzoneClass="dropzoneArea"
                dropzoneText=""
                {...field}
                InputProps={{}}
                onChange={(e) => {
                  props.setFieldValue("appLogo", e);
                }}
                initialFiles={values.appLogo}
                useChipsForPreview={true}
                showAlerts={[]}
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box mr={2}>
            <Box my={2}>
              <InputLabel
                className="helpIcon"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}>
                Les 4 principaux logos de vos partenaires au format PNG (présent
                sur toute les pages)
                <CustomPopover>
                  <p style={{ fontSize: "14px" }}>
                    <i>
                      Ces logos seront accessibles <br /> sur toutes les pages.
                    </i>
                  </p>
                  <img
                    style={{ width: "200px" }}
                    src={logoPartner2}
                    alt="page logo sponsors"
                  />
                </CustomPopover>
              </InputLabel>
            </Box>
            <DropzoneArea
              onChange={(files) => {
                handleChange("sponsorLogos", files);
                props.setFieldValue("sponsorLogos", files);
              }}
              filesLimit={4}
              acceptedFiles={["image/png"]}
              dropzoneClass="dropzoneArea"
              dropzoneText=""
              useChipsForPreview={true}
              showAlerts={[]}
              initialFiles={props.formState.sponsorLogos}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box mr={2}>
            <Box my={2}>
              <InputLabel
                className="helpIcon"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}>
                Les logos de tous vos partenaires au format PNG (présent dans
                l'onglet partnaires)
                <CustomPopover>
                  <p style={{ fontSize: "14px" }}>
                    <i>
                      Un onglet <strong>« partenaires »</strong> est <br />{" "}
                      présent dans l’application, <br />
                      vous pouvez ajouter <br /> autant de logos souhaités
                    </i>
                  </p>
                  <img
                    style={{ width: "200px" }}
                    src={logoPartner}
                    alt="page logo partenaire"
                  />
                </CustomPopover>
              </InputLabel>
            </Box>
            <DropzoneArea
              onChange={(files) => handleChange("partnerLogos", files)}
              filesLimit={20}
              acceptedFiles={["image/png"]}
              dropzoneClass="dropzoneArea"
              dropzoneText=""
              useChipsForPreview={true}
              showAlerts={[]}
              initialFiles={props.formState.partnerLogos}
            />
          </Box>
        </Grid>

        <Grid container justify="flex-end">
          <Box my={2}>
            {props.hasPrev() && (
              <Button
                className="bottom-button"
                size="small"
                onClick={props.prev}
                variant="outlined"
                color="primary">
                Précédent
              </Button>
            )}
            {props.hasNext() && (
              <Button
                disabled={!stepValidated()}
                className="bottom-button"
                size="small"
                onClick={props.next}
                variant="contained"
                color="primary">
                Suivant
              </Button>
            )}
          </Box>
        </Grid>
        <i style={{ opacity: "0.6", fontSize: "12px" }}>* Champ Obligatoire</i>
      </Grid>
    </div>
  );
};

export default Step1;
